import { read, utils } from 'xlsx';
// import XLSX from 'xlsx';
import React, { useState, useRef, useEffect } from 'react';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import UseFetchData from "../../../hooks/UseFetchData";
import Button from '../../biztran_controls/Button';
import { Tooltip } from '@material-ui/core'
import BiztranControls from "../../biztran_controls/BiztranControls";
// import LeadImport from "../../../media/template/LeadImport.xlsx";

import Loader from "../../biztran_controls/Loader";

import Session from "react-session-api";
const XLSX = require('xlsx');
function ProductBulkImport() {
    const [columns, setcolumns] = useState([]);
    const [rows, setrows] = useState([]);
    const [SheetJson, setSheetJson] = useState([]);
    const [response, fetchData] = UseFetchData();
    const [responsecountry, fetchcountry] = UseFetchData();
    const [responseCOMPANY, fetchCOMPANY] = UseFetchData();
    const [responseCurrency, fetchCurrencyData] = UseFetchData();
    const [responseLeadSource, fetchLeadSourceData] = UseFetchData();
    const [validateButton, setvalidateButton] = useState(true);
    const [ComboCountry, setComboCountry] = useState(['']);
    const [CurrencyOptions, setCurrencyOptions] = useState([]);
    const [CMPOptions, setCMPOptions] = useState([]);
    const [indOptions, setindOptions] = useState([]);
    const [cmbLeadSource, setLeadSourcecmb] = useState([]);
    const [LeadSource, setLeadSource] = useState('');
    const [Currency, setCurrency] = useState("");
    const [Country, setCountry] = useState("");
    const [CMP, setCMP] = useState(Session.get("CompanyNameID"));
    const accptfiletype = ['xlsx', 'xls', 'csv'];
    const Listcolumnames = ["id", "ModelCode", "SKU_Description", "SKU_Specifications", "Shipping_Weight", "Unit", "List Price(INR)", "List Price(USD)", "Net Weight"];
    const fileRef = useRef();
    const [loading, setLoading] = useState(true);

    const LeadSourceData = () => {
        var bodyFormData = new FormData();
        setLoading(true);
        fetchLeadSourceData("Product/PriceList", bodyFormData);
    }


    useEffect(() => {
        try {
            if (responseLeadSource !== undefined && responseLeadSource.length > 0) {

                if (responseLeadSource !== undefined) {
                    // setLoading(false);
                    setLeadSourcecmb(responseLeadSource);
                }
            }
        } catch (error) {
            console.log(error);
        }

    }, [responseLeadSource]);

    const uploadExcel = () => {
        var UpdatedByID = sessionStorage.UID;
        var bodyFormData = new FormData();
        bodyFormData.append("DataExcel", SheetJson);
        bodyFormData.append("UpdatedByID", UpdatedByID);
        bodyFormData.append("ProductId", LeadSource);
        setLoading(true);
        fetchData("Product/ProductBulk", bodyFormData);

    }
    useEffect(() => {
        LeadSourceData()
    }, [])

    useEffect(() => {
        try {
            // const gridCols = [
            //     {
            //         field: "id",
            //         hide: true,
            //         headerName: "ID",
            //         // renderCell: (params) => (<strong> <Link to={{ pathname: "/lead/LeadView", state: { LeadID: params.id } }} style={{ color: 'blue' }} >Select</Link> </strong>),
            //         // //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ),
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 70,
            //     },
            //     {
            //         field: "ModelCode",
            //         headerName: "ModelCode",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 150,
            //     },
            //     {
            //         field: "SKU_Description",
            //         headerName: "SKU_Description",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 370,
            //         renderCell: (params) => (
            //             <Tooltip title={params.row.SKU_Description} >
            //                 <span className="table-cell-trucate">{params.row.SKU_Description}</span>
            //             </Tooltip>
            //         )
            //     },
            //     {
            //         field: "SKU_Specifications",
            //         headerName: "SKU_Specifications",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 370,
            //         renderCell: (params) => (
            //             <Tooltip title={params.row.SKU_Specifications} >
            //                 <span className="table-cell-trucate">{params.row.SKU_Specifications}</span>
            //             </Tooltip>
            //         )
            //     },
            //     // {
            //     //   field: "TeamSize",
            //     //   headerName: "Team Size",
            //     //   headerClassName: "super-app-theme--header",
            //     //   headerAlign: "center",
            //     //   width: 200,
            //     // },

            //     {
            //         field: "Shipping_Weight",
            //         headerName: "Shipping Weight",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 170,
            //     },
            //     {
            //         field: "Unit",
            //         headerName: "Unit",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 170,
            //     },
            //     {
            //         field: "List Price(INR)",
            //         headerName: "Price(INR)",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 150,
            //     },
            //     {
            //         field: "List Price(USD)",
            //         headerName: "Price(USD)",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 150,
            //     },

            //     {
            //         field: "Net Weight",
            //         headerName: "Net Weight",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 150,
            //     },
            //     // {
            //     //     field: "Address",
            //     //     headerName: "Address",
            //     //     headerClassName: "super-app-theme--header",
            //     //     headerAlign: "center",
            //     //     width: 200,
            //     //     renderCell: (params) => (
            //     //         <Tooltip title={params.row.BillAddress1} >
            //     //             <span className="table-cell-trucate">{params.row.BillAddress1}</span>
            //     //         </Tooltip>
            //     //     )
            //     // },
            //     {
            //         field: "ImportStatus",
            //         headerName: "Import Status",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 200,
            //     },
            //     {
            //         field: "ImportRemark",
            //         headerName: "Import Remark",
            //         headerClassName: "super-app-theme--header",
            //         headerAlign: "center",
            //         width: 200,
            //         renderCell: (params) => (
            //             <Tooltip title={params.row.ImportRemark} >
            //                 <span className="table-cell-trucate">{params.row.ImportRemark}</span>
            //             </Tooltip>
            //         )
            //     },
            // ];

            debugger;
            const gridCols = [
                {
                    field: "id",
                    headerName: "id",
                    hide: true,
                    // renderCell: (params) =>
                    //     (<strong> <Link to={{ pathname: "/account/AccountView", state: { AccountID: params.id, AccountName: params.row.AccountName } }} style={{ color: 'blue' }} >Select</Link> </strong>)
                    // ,
                    //renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} >Select</a> </strong> ), 
                    headerClassName: "super-app-theme--header",
                    headerAlign: "center",
                    width: 70,
                },

            ];
            debugger;
            const copygridclm = gridCols.slice();
            var clm = {};
            if (response !== undefined && response.length > 0) {
                setLoading(false);
                for (var i = 1; i < Object.keys(response[0]).length; i++) {
                    if (Object.keys(response[0])[i] !== "id" && Object.keys(response[0])[i] !== "SKU_Specifications" && Object.keys(response[0])[i] !== "SKU_Description") {
                        clm = {
                            field: Object.keys(response[0])[i],
                            headerName: Object.keys(response[0])[i],
                            headerClassName: "super-app-theme--header",
                            headerAlign: "center",
                            width: 200,
                        };
                    }
                    else if (Object.keys(response[0])[i] === "SKU_Specifications") {
                        clm = {
                            field: Object.keys(response[0])[i],
                            headerName: Object.keys(response[0])[i],
                            headerClassName: "super-app-theme--header",
                            headerAlign: "center",
                            width: 400,
                            renderCell: (params) => (
                                <Tooltip title={params.row.SKU_Specifications} >
                                    <span className="table-cell-trucate">{params.row.SKU_Specifications}</span>
                                </Tooltip>
                            )
                        };
                    }
                    else if (Object.keys(response[0])[i] === "SKU_Description") {
                        clm = {
                            field: Object.keys(response[0])[i],
                            headerName: Object.keys(response[0])[i],
                            headerClassName: "super-app-theme--header",
                            headerAlign: "center",
                            width: 400,
                            renderCell: (params) => (
                                <Tooltip title={params.row.SKU_Description} >
                                    <span className="table-cell-trucate">{params.row.SKU_Description}</span>
                                </Tooltip>
                            )
                        };
                    }
                    copygridclm.push(clm);
                }
            }
            // setColumns(copygridclm);
            setcolumns(copygridclm);
            if (response !== undefined && response.length > 0) {
                // debugger;
                setLoading(false);
                setrows(response);
            } else {
                // debugger;
                if (response.ResponseCode === 500) {
                    alert('Error:-' + response.message)
                    // alert('Data Saved Succesfully.');
                }
                // debugger;
                setLoading(false);
                setrows([])
            }

        }
        catch (error) {
            console.log(error)
        }

    }, [response]
    );
    const generateExcel = () => {
        // const data = [{
        //     ModelCode: "", SKU_Description: "", SKU_Specifications: "", Shipping_Weight: "", Unit: "", "List Price(INR)": "", "List Price(USD)": "", "Net Weight": ""
        // }];
        debugger;
        var data = [];
        if (rows.length > 0) {
            data = rows;
        } else {
            alert("Please Select Product ...");
            return
        }

        const fileName = "Prodcut.xlsx"
        const workbook = XLSX.utils.book_new();
        const sheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
        const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const element = document.createElement("a");
        const file = new Blob([wbout], { type: "application/octet-stream" });
        element.href = URL.createObjectURL(file);
        element.download = fileName;
        document.body.appendChild(element);
        element.click();
    };

    const rowValidation = (ROwsData) => {
        //validation on Rows

        var arrcolumn = []
        var arrcolumnName = []
        arrcolumn.push({ field: 'id', headerName: 'Sr No' });
        if (ROwsData[0].length === Listcolumnames.length) {
            for (var ik = 0; ik < ROwsData[0].length; ik++) {
                if (ROwsData[0][ik].toLowerCase() === Listcolumnames[ik].toLowerCase()) {
                    arrcolumn.push({ field: ROwsData[0][ik], headerName: ROwsData[0][ik] });
                    arrcolumnName.push(ROwsData[0][ik])
                }
                else {
                    fileRef.current.value = "";
                    alert("invalid Column " + ROwsData[0][ik]);
                    return false
                }
            }
        } else {
            fileRef.current.value = "";
            alert("Invalid Column ..!");
            return false
        }
        setvalidateButton(false);
        return true
    }
    const checkfiletype = (name) => {
        return accptfiletype.includes(name.split(".").pop().toLowerCase());
    }
    const readDataFromExcel = (data) => {
        const wb = read(data);
        var mySheetData = {};
        // Loop Through The Sheets
        for (var i = 0; i < wb.SheetNames.length; i++) {
            let sheetName = wb.SheetNames[i];
            const worksheet = wb.Sheets[sheetName];
            const jsonData = utils.sheet_to_json(worksheet, { blankrows: "", header: 1, }

            );
            const jsonData01 = utils.sheet_to_json(worksheet);
            //Valadtion on Rows and Columns
            if (!rowValidation(jsonData)) {
                return
            }
            mySheetData[sheetName] = jsonData;
            console.log(sheetName);
            const json1 = JSON.stringify(jsonData01);
            var bodyFormData = new FormData();
            console.log(json1);
            setSheetJson(json1);
        }
    }
    const handlefile = async (e) => {
        // handleRemove();
        console.log(e.target.files[0]);
        const myfile = e.target.files[0];
        if (!myfile) return;
        if (!checkfiletype(myfile.name)) {
            fileRef.current.value = "";
            alert("invalid file Type");

            return
        }
        const data = await myfile.arrayBuffer();
        readDataFromExcel(data)
    }
    const handleRemove = () => {
        fileRef.current.value = "";
        setcolumns([]);
        setrows([]);
        setLeadSource('');
        setvalidateButton(true);
    }
    const OnSelectProduct = (Value) => {
        setLeadSource(Value);
        var bodyFormData = new FormData();
        bodyFormData.append("ProductId", Value);
        setLoading(true);
        fetchData("Product/ProductData", bodyFormData);
    }
    return (

        <div className="App">
            {
                loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.5)',
                        zIndex: 10,
                    }}>
                        <Loader />
                    </div>
                )
            }
            <div style={{ float: "left", marginTop: 0, width: "100%" }}>
                <BiztranControls.Select
                    label="Product"
                    id="Product"
                    width={"400px"}
                    options={cmbLeadSource}
                    value={LeadSource}
                    onChange={(e) => OnSelectProduct(e.target.value)}
                />
                <lable style={{ fontSize: 20, color: 'red' }}>
                    *
                </lable>
            </div>
            <div style={{ float: "left", marginTop: 0, width: "100%" }}>
                <input type='file' style={{ marginTop: 5, marginLeft: 5, height: "20%", width: "30%" }} accept={'Xlsx,xls,csv'} onChange={(e) => handlefile(e)} ref={fileRef} />
                <Button
                    color="primary"
                    disabled={validateButton}
                    text=' Validate & Import'
                    onClick={uploadExcel}
                    width='205px'
                    style={{ marginTop: 5, marginLeft: 5, width: "15%" }}
                />
                <Button onClick={generateExcel} disabled={rows.length > 0 ? false : true} style={{ marginTop: 5, marginLeft: 5, width: "15%" }} text="Download Template" color="primary" />
                <Button
                    color="primary"
                    text="Clear"
                    type="Clear"
                    onClick={handleRemove}
                />
            </div>
            <div>
                <div style={{ height: 400, width: '100%' }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        rowsPerPageOptions={[50]}
                        // components={{ Toolbar: GridToolbar }}
                        disableSelectionOnClick
                    />
                </div>
            </div>
        </div>
    );
}
export default ProductBulkImport;
